import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-success',
  templateUrl: './modal-success.component.html',
  styleUrls: ['./modal-success.component.scss']
})
export class ModalSuccessComponent {

  constructor(private dialogRef: MatDialogRef<ModalSuccessComponent>) {
  }

  onNoClick() {
    this.dialogRef.close();
  }
}
